import {isUndefined as _isUndefined} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
/* eslint import/no-unresolved: 0 */
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {reduxForm} from 'redux-form';
import {Button, Header} from 'semantic-ui-react';

import {gql, graphql} from 'react-apollo';
import Authorization from '@appComponents/Authorization';
import {ButtonCancel} from '@appComponents/ButtonCollection';
import {FormWrapper} from '@appComponents/HOCFormWrapper';
import MessageBox from '@appComponents/MessageBox';
import Form from '@appComponents/ReduxFormControls';
import {refetchQueryByName} from '@utils/apollo';
import {showModal, showModalConfirmation} from '@utils/modal';
import {convertToInt} from '@utils/helpers';
import {showPopupMessage} from '@utils/popupMessage/PopupMessageService';
import * as RESOURCES from '@constants/resources';
import {
    DELETED,
    DELETE_CONFIRMATION,
    DELETE_HEADER,
    DELETING,
    NOT_DELETED,
    NOT_SAVED,
    SAVED,
} from '@constants/messages';
import * as CONST from '@constants/variables';
import * as thirdPartyStreamNamesPullGraphQl from '@graphql/clients/thirdPartyStreamNamesPull';

import validate from './validatorProductThirdPartyStreamNamesPull';

export class ProductThirdPartyStreamNamesPullForm extends React.Component {
    static propTypes = {
        CreateThirdPartyStreamNamesPull: PropTypes.func,
        dataForForm: PropTypes.object,
        dataMap: PropTypes.object,
        DeleteThirdPartyStreamNamesPull: PropTypes.func,
        formData: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func,
        resetIndexUrl: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        UpdateThirdPartyStreamNamesPull: PropTypes.func,
    };

    formSubmit = (data) => {
        const dataToSave = {
            ...this.props.dataMap.thirdPartyStreamName,
            ...data,
            third_party_client_pull_origin: convertToInt(data.third_party_client_pull_origin),
        };

        let dataSaved;

        if (0 === dataToSave.id.length) {
            dataSaved = this.props.CreateThirdPartyStreamNamesPull({
                variables: {...dataToSave},
            }).then(() => {
                showPopupMessage(SAVED(`stream name (pull) "${data.stream_name}"`), 'success');
                refetchQueryByName('ThirdPartyStreamNamesPullIndex');
                showModal({isVisible: false});
                this.props.resetIndexUrl();
            }).catch((error) => {
                showPopupMessage(
                    NOT_SAVED(`stream name (pull) "${data.stream_name}"`),
                    'error',
                    true,
                    `${error}`
                );
            });
        } else {
            dataSaved = this.props.UpdateThirdPartyStreamNamesPull({
                variables: {...dataToSave},
            }).then(() => {
                showPopupMessage(SAVED(`stream name (pull) "${data.stream_name}"`), 'success');
                refetchQueryByName('ThirdPartyStreamNamesPullIndex');
                showModal({isVisible: false});
                this.props.resetIndexUrl();
            }).catch((error) => {
                showPopupMessage(
                    NOT_SAVED(`stream name (pull) "${data.stream_name}"`),
                    'error',
                    true,
                    `${error}`
                );
            });
        }

        return dataSaved.then();
    };

    deleteThirdPartyStreamName = (id) => {
        showModalConfirmation({
            text: DELETING(`stream name (pull) "${this.props.dataForForm.thirdPartyStreamName.stream_name}"`),
            size: 'tiny',
        });

        return this.props.DeleteThirdPartyStreamNamesPull({
            variables: {
                id: id,
            },
        }).then(() => {
            showPopupMessage(
                DELETED(`stream name (pull) "${this.props.dataForForm.thirdPartyStreamName.stream_name}"`),
                'success'
            );
            refetchQueryByName('ThirdPartyStreamNamesPullIndex');
            showModal({isVisible: false});
            this.props.resetIndexUrl();
        }).catch((error) => {
            showModal({isVisible: false});
            showPopupMessage(
                NOT_DELETED(`stream name (pull) "${this.props.dataForForm.thirdPartyStreamName.stream_name}"`),
                'error',
                true,
                `${error}`
            );
        });
    };

    handleThirdPartyStreamNameDelete = () => {
        const data = this.props.dataForForm.thirdPartyStreamName;

        showModalConfirmation({
            header: <Header icon='trash' content={DELETE_HEADER('stream name (pull)')}/>,
            onYes: () => (this.deleteThirdPartyStreamName(convertToInt(data.id))),
            onNo: () => this.props.resetIndexUrl(),
            text: DELETE_CONFIRMATION(`stream name (pull) "${this.props.dataForForm.thirdPartyStreamName.stream_name}"`),
            size: 'tiny',
        });
    };

    renderDeleteButton = () => {
        let deleteButton = null;

        if (
            !_isUndefined(this.props.dataForForm.thirdPartyStreamName.id)
            && ('' !== this.props.dataForForm.thirdPartyStreamName.id)
        ) {
            deleteButton =
                <Button
                    color='red'
                    content='Delete'
                    disabled={this.props.submitting}
                    icon='trash'
                    onClick={this.handleThirdPartyStreamNameDelete}
                />;
        }

        return deleteButton;
    };

    closeModal = (e) => {
        e.preventDefault();

        showModal({
            content: null,
            isVisible: false,
        });
        this.props.resetIndexUrl();
    };

    render() {
        const thirdPartyStreamName = this.props.dataForForm.thirdPartyStreamName;

        return (
            <div>
                <Header as='h3' dividing>
                    {(thirdPartyStreamName.id)
                        ? `Stream name (pull) "${thirdPartyStreamName.stream_name}"`
                        : 'Add new stream name (pull)'
                    }
                </Header>
                <MessageBox name='thirdPartyClientProductStreamNamesPullMessage'/>
                <Form.Create
                    loading={this.props.formData.loading}
                    onSubmit={this.props.handleSubmit(this.formSubmit)}
                >
                    <Form.IdField
                        defaultValue={thirdPartyStreamName.id}
                    />
                    <Form.FormRow
                        allowClear={false}
                        component={Form.SemanticSelect}
                        defaultValue={thirdPartyStreamName.third_party_client_pull_origin.id}
                        label='Pull origin'
                        name='third_party_client_pull_origin'
                        options={this.props.dataForForm.pullOrigins}
                        placeholder='Select pull origin'
                        required
                    />
                    <Form.FormRow
                        component={Form.SemanticInput}
                        defaultValue={thirdPartyStreamName.stream_name}
                        label='Stream name'
                        name='stream_name'
                        required
                    />
                    <Form.FormRow
                        component={Form.SemanticInput}
                        defaultValue={thirdPartyStreamName.description}
                        label='Description'
                        name='description'
                    />
                    <Form.FormRowChangelog
                        resources={RESOURCES.THIRD_PARTY_CLIENT_PULL_STREAM_NAME}
                        data={this.props.formData?.thirdPartyStreamName || {}}
                    />
                    <div className='formRow form__footer'>
                        <label/>
                        <Button
                            color='blue'
                            content={thirdPartyStreamName?.id ? 'Save' : 'Create'}
                            disabled={this.props.submitting}
                            icon='save'
                            loading={this.props.submitting}
                            type='submit'
                        />
                        <Authorization
                            combinedResources={false}
                            privileges={CONST.SECURITY_PRIVILEGES_DELETE}
                            resources={RESOURCES.THIRD_PARTY_CLIENT_PULL_STREAM_NAME}
                        >
                            {this.renderDeleteButton()}
                        </Authorization>
                        <ButtonCancel
                            disabled={this.props.submitting}
                            onClick={this.closeModal}
                        >
                            Cancel
                        </ButtonCancel>
                    </div>
                </Form.Create>
            </div>
        );
    }
}

const ProductThirdPartyStreamNamesPullFormRedux = reduxForm({
    form: 'ThirdPartyClientProductStreamNamesPull',
    validate,
})(withRouter(ProductThirdPartyStreamNamesPullForm));

export default compose(
    graphql(gql(thirdPartyStreamNamesPullGraphQl.createThirdPartyStreamNamesPull), {
        name: 'CreateThirdPartyStreamNamesPull',
    }),
    graphql(gql(thirdPartyStreamNamesPullGraphQl.deleteThirdPartyStreamNamesPull), {
        name: 'DeleteThirdPartyStreamNamesPull',
    }),
    graphql(gql(thirdPartyStreamNamesPullGraphQl.updateThirdPartyStreamNamesPull), {
        name: 'UpdateThirdPartyStreamNamesPull',
    })
)(FormWrapper({
    pullOrigins: [],
    thirdPartyStreamName: {
        description: '',
        id: '',
        stream_name: '',
        third_party_client_pull_origin: {id: ''},
    },
}, (ProductThirdPartyStreamNamesPullFormRedux)));
